export const objectToArray = (object) => {
  return Object.keys(object).map((key) => object[key]);
};

/**
 * Resolve current language from www.drupal.org/project/decoupled_router.
 *
 * @see src/js/client.jsx
 * @see src/js/admin-app.jsx
 * @see src/js/server.js
 *
 * @param pathName string
 * @returns {string}
 */
export const getCurrentLanguage = (pathName) => {
  let currentLanguage = "und";
  // @see https://stackoverflow.com/a/47353851
  const languageRegex = /\/((\w{2})\/?$|(\w{2})\/)/i;

  if (languageRegex.test(pathName)) {
    currentLanguage = pathName.substring(1, 3);
  }

  return currentLanguage;
};
